const obj = {
  DbReferencia: '',
  EventoID: '',
  ID: '',
  Mascara: '',
  MaxLenght: '',
  Nome: '',
  Regulamento: '',
  Sensivel: '',
  TgObrigatorio: '',
  Tipo: '',
  Tooltip: '',
  Valor: '',
}

export default function AttributeModel(params = obj) {
  return {
    ...obj,
    ...params,
  };
}
